// extracted by mini-css-extract-plugin
export default {"display-none":"adc__display-none--d2Qzf","u-pointer-cursor":"adc__u-pointer-cursor--uIBJo","header":"adc__header--zVm2y"};